import { render, staticRenderFns } from "./Manent.vue?vue&type=template&id=6f2375fb&scoped=true&"
import script from "./Manent.vue?vue&type=script&lang=js&"
export * from "./Manent.vue?vue&type=script&lang=js&"
import style0 from "./Manent.vue?vue&type=style&index=0&id=6f2375fb&scoped=true&lang=css&"
import style1 from "./Manent.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f2375fb",
  null
  
)

export default component.exports